import React, { useEffect, useState } from "react";
import Up from "../../../../Assets/Images/OMS/up.svg";
import Down from "../../../../Assets/Images/OMS/down.svg";
import { useFormik } from "formik";
import axios from "axios";
import { Box, Button, Card, Modal } from "@mui/material";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import toast from "react-hot-toast";
import { Document, Page } from "react-pdf";
import { pdfjs } from "react-pdf";
import FileDownloadIcon from "@mui/icons-material/FileDownload";
import UploadDocs from "../../common/uploadDocs";
import CloseIcon from "@material-ui/icons/Close";
import IconButton from "@material-ui/core/IconButton";
import ShowPDF from "../../common/pdfViewer";
import Deduction from "../../../../Assets/Images/OMS_New/deductions.svg";
pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`;

function DeductionDetails({ orderId, getOMSData, omsData }) {
  const isPending = omsData?.only_bnps?.ayekart_lvl1_status !== 'Approved' || omsData?.only_bnps?.ayekart_lvl2_status !== 'Approved';

  const [isDeductionDetails, setIsDeductionDetails] = useState(true);
  const [deductionData, setDeductionDetails] = useState();
  const [openDoc, setOpenDoc] = useState(false);
  const handleOpenDoc = () => {
    setOpenDoc(true);
  };
  const handleCloseDoc = () => setOpenDoc(false);
  const [pdfUrl, setPdfUrl] = useState("");
  const [activeModal, setActiveModal] = useState(false);
  const [supplierDoc, setSupplierDoc] = useState([]);
  const addObject = (newObject) => {
    setSupplierDoc([...supplierDoc, newObject]);
  };
  const handleAddObject = (newObject) => {
    addObject(newObject);
  };
  console.log(supplierDoc, "supplierDoc...");
  useEffect(() => {
    axios
      .get(`/api/oms/deductions?order_id=${orderId}`)
      .then((response) => {
        console.log(response?.data?.records?.rows[0]);
        setDeductionDetails(response?.data?.records?.rows[0]);
      })
      .catch((error) => {
        console.log(error);
      });
  }, [orderId]);
  const shortWeight =
    Number(
      omsData?.op_sourceing_details &&
        omsData.op_sourceing_details[0]?.rate_in_qtl *
          omsData.op_sourceing_details[0]?.unloading_weight_short
    ) || 0;
  const gainWeight =
    Number(
      omsData?.op_sourceing_details &&
        omsData.op_sourceing_details[0]?.rate_in_qtl *
          omsData.op_sourceing_details[0]?.unloading_weight_gain
    ) || 0;
  const tds =
    Number(
      omsData?.op_sourceing_details &&
        omsData.op_sourceing_details[0]?.total_invoice_value
    ) * 0.1 || 0;
  const moisture =
    Number(
      omsData?.op_sourceing_details &&
        omsData.op_sourceing_details[0]?.rate_in_qtl * 1.5
    ) || 0;
  const quality =
    Number(
      omsData?.op_sourceing_details &&
        omsData.op_sourceing_details[0]?.rate_in_qtl * 1.5
    ) || 0;
  const other = 0;
  const total_dd = shortWeight + gainWeight + tds + other + moisture + quality;
  const repaymentsAmount =
    Number(
      omsData?.op_sourceing_details &&
        omsData.op_sourceing_details[0]?.total_invoice_value
        ? omsData.op_sourceing_details[0]?.total_invoice_value
        : 0
    ) -
    shortWeight +
    gainWeight +
    tds +
    other +
    moisture +
    quality;

  const initialValues = {
    order_id: orderId,
    weight_short_amount: shortWeight,
    weight_gain_amount: gainWeight,
    tds: tds,
    other_deduction: other,
    moisture_deduction: moisture,
    quality_deduction: quality,
    total_deduction: total_dd,
    repayments_amount: repaymentsAmount,
    attachments: null,
  };

  const handleSubmit = async (values) => {
    const payload = {
      order_id: orderId,
      weight_short_amount: values?.weight_short_amount
        ? values?.weight_short_amount
        : null,
      weight_gain_amount: values?.weight_gain_amount
        ? values?.weight_gain_amount
        : null,
      repayments_amount: values?.repayments_amount
        ? values?.repayments_amount
        : null,
      total_deduction: values?.total_deduction ? values?.total_deduction : null,
      tds: values?.tds ? values?.tds : null,
      other_deduction: values?.other_deduction ? values?.other_deduction : null,
      moisture_deduction: values?.moisture_deduction
        ? values?.moisture_deduction
        : null,
      quality_deduction: values?.quality_deduction
        ? values?.quality_deduction
        : null,
      attachments: deductionData?.attachments
        ? [...deductionData?.attachments, ...supplierDoc]
        : [...supplierDoc],
    };
    try {
      const { data } = await axios.post("/api/oms/deductions", payload);
      if (data.status) {
        formik.resetForm();

        getOMSData();
        toast.success(data.message);
      } else {
        toast.error(data.message);
      }
    } catch (error) {
      console.log(error);
      toast.error(error.response ? error.response.message : "An error occured");
    }
  };
  const formik = useFormik({
    initialValues: initialValues,
    onSubmit: handleSubmit,
  });
  useEffect(() => {
    formik.setValues({
      ...formik.values,
      weight_gain_amount: deductionData?.weight_short_amount
        ? deductionData?.weight_short_amount
        : 0,
      weight_short_amount: deductionData?.weight_short_amount
        ? deductionData?.weight_short_amount
        : 0,
      quality_deduction: deductionData?.quality_deduction
        ? deductionData?.quality_deduction
        : 0,

      moisture_deduction: deductionData?.moisture_deduction
        ? deductionData?.moisture_deduction
        : 0,
      other_deduction: deductionData?.other_deduction
        ? deductionData?.other_deduction
        : 0,
      tds: deductionData?.tds ? deductionData?.tds : 0,
      total_deduction: deductionData?.total_deduction
        ? deductionData?.total_deduction
        : 0,
      repayments_amount: deductionData?.repayments_amount
        ? deductionData?.repayments_amount
        : 0,
    });
  }, [deductionData, formik.setValues]);

  // --------------------------------- view Doc In card -------------------------------------

  const [numPages, setNumPages] = useState(null);
  const [pageNumber, setPageNumber] = useState(1);
  const [clientId, setClientId] = useState();
  function onDocumentLoadSuccess({ numPages }) {
    setNumPages(numPages);
  }

  function changePage(offset) {
    setPageNumber((prevPageNumber) => prevPageNumber + offset);
  }

  function previousPage() {
    changePage(-1);
  }

  function nextPage() {
    changePage(1);
  }

  console.log(deductionData?.attachments);

  // ------------------------------------ View pdf files -----------------------------------------------
  const handleModalClose = () => {
    setPdfUrl("");
    setActiveModal(false);
  };

  const handleModalOpen = (pdfUrl) => {
    setPdfUrl(pdfUrl);
    setActiveModal(true);
  };
  return (
    <div className="shadow-lg m-2 p-2 pb-2 rounded-lg">
      <div className="flex flex-col sm:flex-row justify-between">
        <div className="font-medium text-cyan-950 text-md flex gap-1">
          {" "}
          <img src={Deduction} alt="" />
          <div className="ms-1">Deduction Details</div>
        </div>
        <div>
          {isDeductionDetails ? (
            <div className="font-medium text-cyan-950 text-lg mt-2">
              <img
                src={Up}
                alt=""
                role="button"
                onClick={() => setIsDeductionDetails(!isDeductionDetails)}
              />
            </div>
          ) : (
            <div className="font-medium text-cyan-950 text-lg mt-2">
              <img
                src={Down}
                alt=""
                role="button"
                onClick={() => setIsDeductionDetails(!isDeductionDetails)}
              />
            </div>
          )}
        </div>
      </div>
      <div>
        <hr className="font-bold text-neutral-500 bg-gray-900 h-0.5" />
      </div>

      <div>
        {isDeductionDetails ? (
          <div>
            <form onSubmit={formik.handleSubmit}>
              <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-2">
                <div>
                  <label
                    for="weight_short_amount"
                    className="block mb-2 text-sm font-medium text-blue-900 dark:text-white flex justify-start ms-1"
                  >
                    Weight Short Amount
                  </label>
                  <input
                    type="number" onWheel={(e) => e.target.blur()}
                    id="weight_short_amount"
                    className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                    name="weight_short_amount"
                    placeholder="Entar Weight Short Amount"
                    value={formik.values.weight_short_amount}
                    onChange={formik.handleChange}
                    disabled
                  />
                </div>
                <div>
                  <label
                    for="weight_gain_amount"
                    className="block mb-2 text-sm font-medium text-blue-900 dark:text-white flex justify-start ms-1"
                  >
                    {" "}
                    Weight Gain Amount
                  </label>
                  <input
                    type="number" onWheel={(e) => e.target.blur()}
                    id="weight_gain_amount"
                    className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                    name="weight_gain_amount"
                    placeholder="Enter Weight Gain Amount"
                    value={formik.values.weight_gain_amount}
                    onChange={formik.handleChange}
                    disabled
                  />
                </div>
                <div>
                  <label
                    for="quality_deduction"
                    className="block mb-2 text-sm font-medium text-blue-900 dark:text-white flex justify-start ms-1"
                  >
                    {" "}
                    Quality Deduction
                  </label>
                  <input
                    type="number" onWheel={(e) => e.target.blur()}
                    id="quality_deduction"
                    className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                    name="quality_deduction"
                    placeholder="Enter Quality Deduction"
                    value={formik.values.quality_deduction}
                    onChange={formik.handleChange}
                    disabled
                  />
                </div>
                <div>
                  <label
                    for="moisture_deduction"
                    className="block mb-2 text-sm font-medium text-blue-900 dark:text-white flex justify-start ms-1"
                  >
                    {" "}
                    Moisture Deduction
                  </label>
                  <input
                    type="number" onWheel={(e) => e.target.blur()}
                    id="moisture_deduction"
                    className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                    name="moisture_deduction"
                    placeholder="Enter Moisture Deduction"
                    value={formik.values.moisture_deduction}
                    onChange={formik.handleChange}
                    disabled
                  />
                </div>
                <div>
                  <label
                    for="other_deduction"
                    className="block mb-2 text-sm font-medium text-blue-900 dark:text-white flex justify-start ms-1"
                  >
                    {" "}
                    Other Dedution
                  </label>
                  <input
                    type="number" onWheel={(e) => e.target.blur()}
                    id="other_deduction"
                    className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                    name="other_deduction"
                    placeholder="Enter Other Dedution"
                    value={formik.values.other_deduction}
                    onChange={formik.handleChange}
                    disabled
                  />
                </div>
                <div>
                  <label
                    for="tds"
                    className="block mb-2 text-sm font-medium text-blue-900 dark:text-white flex justify-start ms-1"
                  >
                    {" "}
                    TDS
                  </label>
                  <input
                    type="number" onWheel={(e) => e.target.blur()}
                    id="tds"
                    className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                    name="tds"
                    placeholder="Enter TDS"
                    value={formik.values.tds}
                    onChange={formik.handleChange}
                    disabled
                  />
                </div>
                <div>
                  <label
                    for="total_deduction"
                    className="block mb-2 text-sm font-medium text-blue-900 dark:text-white flex justify-start ms-1"
                  >
                    {" "}
                    Total Deduction
                  </label>
                  <input
                    type="number" onWheel={(e) => e.target.blur()}
                    id="total_deduction"
                    className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                    name="total_deduction"
                    placeholder="Enter Total Deduction"
                    value={formik.values.total_deduction}
                    onChange={formik.handleChange}
                    disabled
                  />
                </div>
                <div>
                  <label
                    for="repayments_amount"
                    className="block mb-2 text-sm font-medium text-blue-900 dark:text-white flex justify-start ms-1"
                  >
                    {" "}
                    Repayments Amount
                  </label>
                  <input
                    type="number" onWheel={(e) => e.target.blur()}
                    id="repayments_amount"
                    className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                    name="repayments_amount"
                    placeholder="Enter Repayments Amount "
                    value={formik.values.repayments_amount}
                    onChange={formik.handleChange}
                    disabled
                  />
                </div>
              </div>
              {deductionData?.attachments?.length > 0 ? (
                <div className="flex justify-start mt-2">
                  {" "}
                  <h4 className="text-blue-900">Uploaded Documents</h4>
                </div>
              ) : (
                ""
              )}
              <div className="grid grid-cols-1 sm:grid-cols-1 md:grid-cols-2 lg:grid-cols-3 mt-2 gap-4">
                {deductionData?.attachments?.length > 0 &&
                  deductionData?.attachments?.map((item, index) => {
                    return (
                      <>
                        <Card
                          sx={{
                            width: ["100%", "100%", "100%", "100%"],
                            bgcolor: "background.paper",
                            boxShadow: 24,
                            borderRadius: 4,
                            maxHeight: 300,
                            overflow: "auto",
                            backgroundColor: "#FEFEFE",
                          }}
                        >
                          <div className="flex justify-between m-2 mb-2">
                            <h5 className="text-center mt-2">
                              {" "}
                              {item?.type} Document
                            </h5>
                            <div className="flex justify-center">
                              <h5 className="flex justify-between  text-teal-700 mt-2 ">
                                <Button
                                >
                                  <FileDownloadIcon
                                    icon="subway:download-1"
                                    width="24"
                                    height="24"
                                    className="ms-3"
                                    role="button"
                                  />
                                  <a
                                    style={{
                                      textDecoration: "none",
                                      color: "inherit",
                                    }}
                                    href={item?.url}
                                  >
                                    Download
                                  </a>
                                </Button>
                              </h5>
                              <Button
                                onClick={() => handleModalOpen(item?.url)}
                              >
                                {" "}
                                View
                              </Button>
                            </div>
                          </div>

                          <div className=" flex justify-center border-2 mt-4 pb-5 border-b-teal-900  p-3">
                            {item?.url?.includes(".pdf") ? (
                              <Document
                                maxHeight={200}
                                maxWidth={300}
                                file={item?.url}
                                onLoadSuccess={onDocumentLoadSuccess}
                                onLoadError={(error) =>
                                  console.error(
                                    "Error while loading document!",
                                    error
                                  )
                                }
                              >
                                <Page pageNumber={pageNumber} />
                              </Document>
                            ) : (
                              <img src={item?.url} alt="" />
                            )}
                          </div>
                          <div className="flex justify-between mt-5 pb-3">
                            <p className="">
                              Page {pageNumber || (numPages ? 1 : "--")} of{" "}
                              {numPages || "--"}
                            </p>
                            <div className="flex gap-2">
                              <Button
                                size="small"
                                variant="contained"
                                disabled={pageNumber <= 1}
                                onClick={previousPage}
                                sx={{ backgroundColor: "#040D43" }}
                              >
                                Previous
                              </Button>
                              <Button
                                size="small"
                                className="ml-2"
                                variant="contained"
                                disabled={pageNumber >= numPages}
                                onClick={nextPage}
                                sx={{ backgroundColor: "#040D43" }}
                              >
                                Next
                              </Button>
                            </div>
                          </div>
                        </Card>
                      </>
                    );
                  })}
              </div>
              <div className="grid grid-cols-1 sm:grid-cols-1 md:grid-cols-1 lg:grid-cols-1 gap-3 mt-2 ">
                <div>
                  <label
                    for="branch"
                    className="block mb-2 text-sm font-medium text-blue-900 dark:text-white flex justify-start ms-1"
                  >
                    Add Documents
                  </label>
                  <Button
                    sx={{ backgroundColor: "gray" }}
                    variant="contained"
                    className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                    onClick={() => handleOpenDoc()}
                    disabled={isPending}
                  >
                    <CloudUploadIcon />
                    <b className="ms-2 mt-1">Upload Documents</b>
                  </Button>
                </div>
              </div>
              <div className="flex justify-end mt-2">
                {/*<Button 
                      color="error"
                      onClick={(e) => formik.resetForm()}
                    >
                      CLEAR
                    </Button>
                    */}
                <Button
                  variant="contained"
                  size="small"
                  type="submit"
                  sx={{ backgroundColor: "#0D9223" }}
                  disabled={isPending}
                >
                  SAVE
                </Button>
              </div>
            </form>
            {/* <ToastContainer /> */}
          </div>
        ) : (
          ""
        )}
      </div>
      <UploadDocs
        open={openDoc}
        handleClose={handleCloseDoc}
        handleAddObject={handleAddObject}
      />
      <Modal
        open={activeModal}
        onClose={handleModalClose}
        aria-labelledby="simple-modal-title"
        aria-describedby="simple-modal-description"
      >
        <Box
          sx={{
            position: "absolute",
            width: "50%",
            height: "80%",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            bgcolor: "background.paper",
            boxShadow: 24,
            p: 4,
            overflowY: "auto",
          }}
        >
          <div className="">
            <IconButton
              aria-label="close"
              style={{ position: "absolute", right: "8px", top: "8px" }}
              onClick={() => handleModalClose()}
            >
              <CloseIcon />
            </IconButton>
          </div>
          <div className="flex flex-col items-center justify-center space-y-5 h-full">
            {pdfUrl?.toLowerCase().endsWith(".pdf") ? (
              <ShowPDF pdfUrl={pdfUrl} />
            ) : (
              <img src={pdfUrl} alt="uploaded image" />
            )}
          </div>
        </Box>
      </Modal>
    </div>
  );
}

export default DeductionDetails;
